<template>
  <div class="resetPassword loginCom">
    <returnPage
      @resetPsdPush="resetPsdPush"
      type="resetPsdPush"
       v-if="!this.$root.miniprogram"
    />
    <div class="resetPsdMain loginMmain">
      <div class="resetPsdText">重置密码</div>

      <div class="resetUserInfo">
        <div class="phoneIpt">
          <input
            type="password"
            placeholder="请输入新密码"
            class="userNewPsd"
            v-model="userNewPsd"
            @keydown="myKeydown"
            maxlength="18"
            @input="userPsdIpt"
          />
        </div>
        <div class="loginLine"></div>

        <div class="psdIpt">
          <input
            :type="showHide ? 'password' : 'text'"
            placeholder="再次输入新密码"
            class="userConfirmPsd"
            v-model="userConfirmPsd"
            @keydown="myKeydown"
            maxlength="18"
          />
          <span
            :class="{ eyeHide: showHide, eyeShow: !showHide }"
            id="eye_icon"
            @click="showHidePsd"
          ></span>
        </div>
        <div class="resetPsdLine loginLine"></div>
      </div>
    </div>

    <sendButton
      buttonText="确认"
      @sendCodeBtn="resetPassword"
      :yuntuColor="yuntuColor"
      loginWay="resetPassword"
      :activeLoginBtn="activeLoginBtn"
    />
  </div>
</template>

<script>
import '@/assets/css/loginCommon.css';
import { Toast } from 'vant';
import returnPage from '@/components/login/returnPage.vue';
import sendButton from '@/components/login/sendButton.vue';
import { resetPsd } from '@/api/login';

export default {
  props: ['type', 'code'],
  components: {
    returnPage,
    sendButton,
  },
  data() {
    return {
      showHide: true,
      userConfirmPsd: '',
      userNewPsd: '',
      activeLoginBtn: false,
      urlParams: '',
      pagesParams: '',
      yuntuColor:false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    myKeydown() {
      const { userNewPsd, userConfirmPsd } = this;
      this.userNewPsd = userNewPsd.replace(/\s+/g, '');
      this.userConfirmPsd = userConfirmPsd.replace(/\s+/g, '');
    },
    showHidePsd() {
      if (this.userConfirmPsd?.length < 1) return;
      this.showHide = !this.showHide;
    },

    userPsdIpt() {
      if (this.userNewPsd.length >= 8) {
        this.activeLoginBtn = true;
        return;
      }
      this.activeLoginBtn = false;
    },

    async resetPassword() {
      if (!this.activeLoginBtn) return;
      const { userNewPsd, userConfirmPsd } = this;
      // const userReg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[.%-+#/*_])[\da-zA-Z~.%-+#/*_]{6,18}$/i;
      // /^[a-zA-Z0-9@\$\^\.\*\\?]{6,15}$/;
      // const userReg = /^[\da-zA-Z~.%-+#/*_]{6,18}$/;
      let params = null;

      // if (!userReg.test(userNewPsd) || !userReg.test(userConfirmPsd)) {
      //   Toast('密码8-18位，由数字、字母大小写、字符组合而成');
      //   return;
      // }
      if (userNewPsd !== userConfirmPsd) {
        Toast('两次密码输入不一致，请重新输入');
        return;
      }

      params = {
        phone: String(this.$store.state.userPhone),
        password: String(userNewPsd),
        smsCode: String(JSON.parse(this.pagesParams)?.code),
        type: 'forgetPassword',
      };
      const result = await resetPsd(params);
      if (result?.code === 0) {
        Toast({
          type: 'success',
          message: '修改成功',
          duration: 3 * 1000,
        });
        setTimeout(() => {
          this.$router.replace({
            path: '/registrationLogin',
            query: { redirect: this.$route.query.redirect, redirctUrl: this.$route.query.redirect },
            params: this.pagesParams,
          });
        }, 1500);
      } else {
        Toast(result?.msg || '修改失败，请稍后重试');
      }
    },
    resetPsdPush() {
      const obj = Object.assign(this.pagesParams ? JSON.parse(this.pagesParams) : {}, {
        loginWay: 'forgetPassword',
        fromPath: 'resetPassword',
      });

      this.$router.replace({
        name: 'getCode',
        // path: '/getCode',
        query: JSON.parse(this.urlParams),
        params: obj,
      });
    },
    Toast(msg) {
      Toast({
        message: msg,
        duration: 3 * 1000,
        position: 'top',
      });
    },
  },
  created() {
    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams');
    if((JSON.parse(this.pagesParams))?.loginSource==='yuntulogin'){this.yuntuColor= true}
  },
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'background-color:#fff');
  },
  beforeDestroy() {
    clearTimeout();
    document.getElementsByClassName('app')[0].removeAttribute('style');
  },
};
</script>
<style lang="scss" scoped>
.resetPassword {
  .resetPsdText {
    padding: 89px 0 149px 0;
    color: #333;
    font-weight: 500;
    font-size: 51px;
  }

  .resetUserInfo {
    line-height: 14px;

    .psdIpt {
      position: relative;
      padding-top: 34px;

      #eye_icon {
        position: absolute;
        right: 109px;
        display: inline-block;
        width: 33px;
        height: 43px;
        background-size: 33px;
      }
      .eyeHide {
        bottom: 4px;
        background: no-repeat url('../../assets/img/registrationLogin/eyeHide.png');
      }

      .eyeShow {
        bottom: 0;
        background: no-repeat url('../../assets/img/registrationLogin/eyeShow.png');
      }
    }
  }
  .resetPsdLine {
    margin-bottom: 42px;
  }
  input {
    width: 500px;
    padding: 22px 0;
  }
}
</style>
